export const PDC_FIELD_NAME = "Point de contact";

export const shouldSynchronizePdcField = (previousProps, currentProps) => {
  if (currentProps.isToBeModified || !currentProps.selectedSector) return false;

  const selectedPdcChanged = previousProps.selectedPdcId !== currentProps.selectedPdcId;
  const creationModalOpened = !previousProps.visibleCreationModal && currentProps.visibleCreationModal;

  return selectedPdcChanged || creationModalOpened;
};



// WEBPACK FOOTER //
// src/components/planning/eventForm.utils.js